const WEATHER_CODES = {
  0: "Clear sky",
  1: "Mainly clear",
  2: "Partly cloudy",
  3: "Overcast",
  45: "Fog",
  48: "Depositing rime fog",
  51: "Light drizzle",
  53: "Moderate drizzle",
  55: "Dense drizzle",
  56: "Freezing drizzle",
  57: "Dense freezing drizzle",
  61: "Slight rain",
  63: "Moderate rain",
  65: "Heavy rain",
  66: "Freezing rain",
  67: "Heavy freezing rain",
  71: "Slight snow",
  73: "Moderate snow",
  75: "Heavy snow",
  80: "Slight rain showers",
  81: "Moderate rain showers",
  82: "Violent rain showers",
  85: "Snow showers",
  95: "Thunderstorm",
  96: "Thunderstorm with hail",
  99: "Severe thunderstorm with hail",
};

export async function fetchWeather(lat, lng) {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m,precipitation`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("weather fetch failed");
  const j = await res.json();
  const c = j.current;
  const desc = WEATHER_CODES[c.weather_code] || "Unknown";
  return `${desc}, ${Math.round(c.temperature_2m)}°C, wind ${Math.round(
    c.wind_speed_10m
  )} km/h, precip ${c.precipitation} mm (captured ${new Date().toLocaleString()})`;
}

function fmtDate(d) {
  return d.toISOString().slice(0, 10);
}

// Estimate the weather at a specific past time using open-meteo's hourly
// forecast archive (past_days covers recent crashes; falls back to archive API).
export async function fetchWeatherAt(lat, lng, isoTime) {
  const when = new Date(isoTime);
  const now = new Date();
  const daysAgo = Math.ceil((now - when) / 86400000);
  const hourly = "temperature_2m,relative_humidity_2m,precipitation,weather_code,wind_speed_10m";
  let url;
  if (daysAgo <= 7) {
    const past = Math.min(Math.max(daysAgo + 1, 1), 92);
    url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&hourly=${hourly}&past_days=${past}&forecast_days=1`;
  } else {
    url = `https://archive-api.open-meteo.com/v1/archive?latitude=${lat}&longitude=${lng}&start_date=${fmtDate(when)}&end_date=${fmtDate(when)}&hourly=${hourly}`;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error("historical weather unavailable");
  const j = await res.json();
  const times = j.hourly?.time || [];
  if (!times.length) throw new Error("no data for that time");
  const target = when.getTime();
  let best = 0;
  let bestDiff = Infinity;
  times.forEach((t, i) => {
    const diff = Math.abs(new Date(t).getTime() - target);
    if (diff < bestDiff) {
      bestDiff = diff;
      best = i;
    }
  });
  const h = j.hourly;
  const desc = WEATHER_CODES[h.weather_code[best]] || "Unknown";
  return `${desc}, ${Math.round(h.temperature_2m[best])}°C, ${h.relative_humidity_2m[best]}% humidity, wind ${Math.round(
    h.wind_speed_10m[best]
  )} km/h, precip ${h.precipitation[best]} mm (estimated for ${new Date(times[best]).toLocaleString()})`;
}

export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Geolocation not supported"));
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          capturedAt: new Date().toISOString(),
        }),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
}
